import { createContext } from "react";
import "./DisplayContext.scss";

export const DisplayContext = createContext();

// inline-block, block, block-fill, scrolled
export const getDisplayClass = (display) => `_${display}`;